
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const apiEndpoints = [
  { 
    name: "Market Data", 
    endpoint: "/v1/market-data", 
    description: "Real-time and historical pricing data for stocks, options, and other assets." 
  },
  { 
    name: "Portfolio Management", 
    endpoint: "/v1/portfolio", 
    description: "Create, update, and track investment portfolios." 
  },
  { 
    name: "Strategy Analysis", 
    endpoint: "/v1/strategy", 
    description: "Test and analyze trading strategies using historical data." 
  },
];

export const DocsAPISection = () => (
  <div>
    <Card className="bg-gray-800/40 border-gray-700/50 mb-8">
      <CardHeader>
        <CardTitle className="text-white">Getting Started with Stewie API</CardTitle>
        <CardDescription className="text-gray-300">
          Everything you need to start integrating with our platform.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-gray-300 mb-4">
          The Stewie API gives you programmatic access to all of our platform's capabilities.
          With our API, you can integrate trading algorithms, access market data, and manage portfolios directly from your applications.
        </p>
        <div className="bg-gray-900/60 p-4 my-4 rounded-md border border-gray-700">
          <h4 className="text-lg font-medium text-white mb-2">Authentication</h4>
          <p className="text-gray-300 text-sm">
            Authentication to the API is done via API keys. You can generate API keys in your account settings.
          </p>
          <pre className="mt-3 p-3 bg-gray-950 rounded text-sm text-gray-300 overflow-x-auto">
            <code>
              curl -X GET "https://api.stewietrader.com/v1/market-data" \<br/>
              &nbsp;&nbsp;-H "Authorization: Bearer YOUR_API_KEY"
            </code>
          </pre>
        </div>
        <div className="mt-6">
          <Button className="bg-blue-600 hover:bg-blue-700 mr-3">
            View Full API Reference
          </Button>
          <Button variant="outline" className="border-gray-700 text-gray-300">
            Get API Key
          </Button>
        </div>
      </CardContent>
    </Card>
    <h3 className="text-xl font-semibold text-white mb-4">API Endpoints</h3>
    <div className="space-y-4">
      {apiEndpoints.map((api, index) => (
        <Card key={index} className="bg-gray-800/40 border-gray-700/50 overflow-hidden">
          <div className="p-5">
            <div className="flex justify-between items-start">
              <div>
                <h4 className="text-lg font-semibold text-white mb-1">{api.name}</h4>
                <Badge variant="outline" className="mb-2 text-green-400 border-green-500/30 font-mono">
                  {api.endpoint}
                </Badge>
                <p className="text-gray-300 text-sm mt-2">{api.description}</p>
              </div>
              <Button size="sm" variant="outline" className="border-gray-700 text-gray-300">
                View Docs
              </Button>
            </div>
          </div>
        </Card>
      ))}
    </div>
  </div>
);
